import api from "@/interceptors/axios";
import { socialErrorMessage } from "@/server/SocialService";

const BLOG_PREFIX = "api/blog";

export { socialErrorMessage as blogErrorMessage };

export const getBlogCategories = () => api.get(`${BLOG_PREFIX}/categories`);

export const getBlogPosts = ({ category = null, query = null, cursor = null, limit = 12 } = {}) => {
  const params = { limit };
  if (category) params.categoria = category;
  if (query) params.q = query;
  if (cursor) params.cursor = cursor;
  return api.get(`${BLOG_PREFIX}/posts`, { params });
};

export const getBlogPost = (slug) => api.get(`${BLOG_PREFIX}/posts/${encodeURIComponent(slug)}`);

export const getBlogFeaturedPosts = () => api.get(`${BLOG_PREFIX}/posts/destaques`);

export const createBlogPost = (payload) =>
  api.post(`${BLOG_PREFIX}/posts`, blogPostFormData(payload), multipartConfig());

export const updateBlogPost = (postId, payload) =>
  api.post(`${BLOG_PREFIX}/posts/${postId}/update`, blogPostFormData(payload), multipartConfig());

export const deleteBlogPost = (postId) => api.delete(`${BLOG_PREFIX}/posts/${postId}`);

export const likeBlogPost = (postId) => api.post(`${BLOG_PREFIX}/posts/${postId}/likes`);
export const unlikeBlogPost = (postId) => api.delete(`${BLOG_PREFIX}/posts/${postId}/likes`);

export const saveBlogPost = (postId) => api.post(`${BLOG_PREFIX}/posts/${postId}/saves`);
export const unsaveBlogPost = (postId) => api.delete(`${BLOG_PREFIX}/posts/${postId}/saves`);

export const getSavedBlogPosts = ({ cursor = null, perPage = 12 } = {}) => {
  const params = { per_page: perPage };
  if (cursor) params.cursor = cursor;
  return api.get(`${BLOG_PREFIX}/saved`, { params });
};

export const getBlogComments = (postId, cursor = null, perPage = 10) =>
  api.get(`${BLOG_PREFIX}/posts/${postId}/comments`, {
    params: { per_page: perPage, ...(cursor ? { cursor } : {}) },
  });
export const createBlogComment = (postId, content) =>
  api.post(`${BLOG_PREFIX}/posts/${postId}/comments`, { content });
export const updateBlogComment = (commentId, content) =>
  api.put(`${BLOG_PREFIX}/comments/${commentId}`, { content });
export const deleteBlogComment = (commentId) => api.delete(`${BLOG_PREFIX}/comments/${commentId}`);

function blogPostFormData({ title = "", content = "", categoryId = null, images = [], keptImageIds = null }) {
  const form = new FormData();
  form.append("title", title == null ? "" : String(title));
  form.append("content", content == null ? "" : String(content));
  form.append("social_post_category_id", categoryId == null ? "" : String(categoryId));

  if (Array.isArray(keptImageIds)) {
    form.append("kept_image_ids", JSON.stringify(keptImageIds));
  }

  images.forEach((image) => form.append("images[]", image));
  return form;
}

function multipartConfig() {
  return { headers: { "Content-Type": undefined } };
}